import { Box, styled, Typography } from '@mui/material';

export const StyledBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '2rem'
});

export const StyledTypography = styled(Typography)({
  fontSize: '2.25rem',
  marginBottom: '1rem'
});

export const StyledSubtitleTypography = styled(Typography)({
  fontSize: '1rem',
  fontWeight: 'normal'
});